import { useBusinessStore } from '../../../stores/businessStore';
import { ProductItem } from './product-item/product-item.component';
import { style } from './products.module.css';

import {
  Text,
  Table,
  TableHeader 
} from '@recargas-dominicanas/core/components';


export function Products() {

  const { products } = useBusinessStore();

  return (
    <div className={style.container}>
      <Table style={style.table}>
        <TableHeader style={style.tableHeader}>
          <Text text='Logo'/>
          <Text text='Nombre'/>
          <Text text='Tipo'/>
          <Text text='Beneficio'/>
          <span></span>
        </TableHeader>
        <tbody>
          {
            products?.map(product => (
              <ProductItem
                key={product.id}
                businessProduct={product}/>
            ))
          }
        </tbody>
      </Table>
    </div>
  );
}
